import { dsClass } from '../../common/constants/dsClasses.js';
import { t } from '../../common/i18n/index.js';
import './PublicSoftwareProductsHeader.scss';

export const PublicSoftwareProductsHeader = () => (
  <div className="of-public-page-header-card">
    <h1 className={`${dsClass.H1} ${dsClass.TEXT_ALIGN_CENTER}`}>{t.S0PU('Elisa Yritystietoturva')}</h1>
    <p className={`${dsClass.TEXT_LEAD} ${dsClass.TEXT_ALIGN_CENTER} ${dsClass.FONT_WEIGHT_700}`}>
      {t.BPVB('Suojaa yrityksesi laitteet F-Securen tietoturvalla')}
    </p>
    <p className={`${dsClass.TEXT_LEAD} ${dsClass.TEXT_ALIGN_CENTER} ${dsClass.MARGIN_BOTTOM_0}`}>
      Elisa Yritystietoturva tuo kattavan tietoturvan kaikkiin laitteisiisi ja suojaa tärkeitä tietojasi verkon
      haittaohjelmilta, viruksilta ja identiteettivarkauksilta.
    </p>
    <div className={`${dsClass.TEXT_L} ${dsClass.TEXT_ALIGN_CENTER} ${dsClass.MARGIN_BOTTOM_0}`}>
      <p className={dsClass.MARGIN_BOTTOM_3}>
        Elisa Yritystietoturva pohjautuu F-Securen Total -palveluun, joka tuo suojan Windows- ja Mac-tietokoneiden
        lisäksi Android- ja iOS-puhelimiin ja tabletteihin.
      </p>
      <p className={dsClass.MARGIN_BOTTOM_3}>
        Yritystietoturva takaa virusten torjunnan, selauksen suojauksen ja VPN:n lisäksi nyt myös henkilötietojen
        suojauksen ja salasanojen hallinnan. Salaa yhteytesi ja tee töitä huoletta myös julkisessa Wi-Fi-verkossa.
      </p>
      <p>Tilaa yrityksellesi kattava Elisa Yritystietoturva!</p>
    </div>
  </div>
);
